<template>
	<ja-modal :show="isModalVisible" class="info-modal lock-modal">
		<ja-close-button
			v-if="closable"
			name="close"
			@click.native="closeModal()"
		></ja-close-button>
		<div class="modal-content text--center">
			<div class="modal__title d-flex content--center mb--2 mt--2">
				<ja-icon>
					<svgicon name="lock"></svgicon>
				</ja-icon>
			</div>
			<h3 v-if="hasTitle" class="modal__title heading-3 mb--0 text--center">
				{{ $t('passcodeIsRequired') }}
			</h3>
			<p class="mt--2 mb--2">
				{{ $t('passcodeModalText') }}
			</p>
			<div class="passcode">
				<ja-input
					v-model="userPasscode"
					name="passcode"
					:label="$t('passcodeInputLabel')"
					:placeholder="$t('passcodeInputPlaceholder')"
					:max-length="3"
					is-number-input
					:external-errors="passcodeValidationErrors"
				></ja-input>
			</div>
		</div>

		<div
			v-if="hasButtons"
			class="btn-group mt--2 btn-group--right"
			:style="
				showButtonBack
					? { 'justify-content': 'space-between' }
					: { 'justify-content': 'flex-end' }
			"
		>
			<ja-button
				v-if="showButtonBack"
				name="back"
				class="small left"
				@click.native="onBack()"
			>
				<svgicon name="arrow-left"></svgicon>
				{{ confirmText || $t('back') }}
			</ja-button>
			<ja-button
				name="confirm"
				:disabled="userPasscode.length < 3 || isNextButtonDisabled"
				class="small right"
				@click.native="confirm()"
			>
				{{ confirmText || $t('next') }}
				<svgicon name="arrow-right"></svgicon>
			</ja-button>
		</div>
	</ja-modal>
</template>

<script>
import Modal from '@/components/Modal/Modal';
import { CloseButton, Button, Icon } from '@ui';
import { Input } from '@ui/form';

import UserData from '@/mixins/UserData';
import ProfileData from '@/mixins/ProfileData';

import { lockGameStages, lifeStageOrders } from '@/helpers/constants';

import ProfileService from '@/services/ProfileService';

export default {
	components: {
		jaModal: Modal,
		jaCloseButton: CloseButton,
		jaButton: Button,
		jaIcon: Icon,
		jaInput: Input
	},
	mixins: [UserData, ProfileData],
	props: {
		title: {
			type: String,
			default: 'Information'
		},
		hasButtons: {
			type: Boolean,
			default: true
		},
		hasTitle: {
			type: Boolean,
			default: true
		},
		cancelText: {
			type: String,
			default: ''
		},
		confirmText: {
			type: String,
			default: ''
		},
		closable: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			userPasscode: '',
			show: false,
			passcodeValidationErrors: [],
			isNextButtonDisabled: false,
			closet: this.closable,
			newLockState: ''
		};
	},
	computed: {
		isModalVisible() {
			if (this.profileData) {
				const lockState = this.$store.getters.getLockState;
				if (lockState === lockGameStages.LIFE_STAGE_SUMMARY) {
					this.$emit('onLifeStageSummary', true);
				}

				return lockState !== lockGameStages.SHOPPING;
			} else {
				return false;
			}
		},
		showButtonBack() {
			const lockState = this.$store.getters.getLockState;
			return (
				lockState === lockGameStages.LIFE_STAGE_SUMMARY ||
				lockState === lockGameStages.BUDGETING ||
				lockState === lockGameStages.AFTER_LIFE_STAGE_INTRO ||
				lockState === lockGameStages.AFTER_CALCULATE_NMI ||
				lockState === lockGameStages.LIFE_SCENARIO
			);
		}
	},
	watch: {
		userPasscode() {
			this.passcodeValidationErrors = [];
		},
		isModalVisible() {
			this.userPasscode = '';
		},
		'$store.getters.getLockState': function(newLockState) {
			this.newLockState = newLockState;
			this.handleLockStateChange(newLockState);
		}
	},
	methods: {
		closeModal() {
			this.$emit('closeModal');
		},
		handleLockStateChange(newLockState) {
			if (
				newLockState === lockGameStages.AFTER_LIFE_STAGE_INTRO ||
				newLockState === lockGameStages.AFTER_CALCULATE_NMI ||
				newLockState === lockGameStages.LIFE_SCENARIO
			) {
				//this.showButtonBack = true;
			} else {
				//this.showButtonBack = false;
			}
		},
		async onBack() {
			if (this.$store.getters.getLockState === lockGameStages.LIFE_SCENARIO) {
				this.$emit('backModal', 0);
			}
			if (this.newLockState === lockGameStages.AFTER_LIFE_STAGE_INTRO) {
				this.$emit('backModal', 1);
			} else if (this.newLockState === lockGameStages.AFTER_CALCULATE_NMI) {
				this.$emit('backModal', 2);
			} else if (this.newLockState === lockGameStages.BUDGETING) {
				this.$emit('backModal', 3);
			}
			this.$store.dispatch('hideModalPassCode');
		},
		async confirm() {
			this.passcodeValidationErrors = [];

			let passcodeToCheck;
			if (this.$store.getters.getLockState === lockGameStages.LIFE_SCENARIO) {
				this.lockGameStage = lockGameStages.LIFE_SCENARIO;
				passcodeToCheck = this.profileData.passcodes.afterLifeScenarioPasscode;
			} else if (
				this.$store.getters.getLockState === lockGameStages.BUDGETING
			) {
				this.lockGameStage = lockGameStages.BUDGETING;
				passcodeToCheck = this.profileData.passcodes.afterSetBudgetPasscode;
			} else if (
				this.$store.getters.getLockState ===
				lockGameStages.AFTER_LIFE_STAGE_INTRO
			) {
				this.lockGameStage = lockGameStages.AFTER_LIFE_STAGE_INTRO;
				passcodeToCheck = this.profileData.passcodes
					.afterLifeStageIntroPasscode;
			} else if (
				this.$store.getters.getLockState === lockGameStages.AFTER_CALCULATE_NMI
			) {
				this.lockGameStage = lockGameStages.AFTER_CALCULATE_NMI;
				passcodeToCheck = this.profileData.passcodes.afterCalculateNMIPasscode;
			} else if (
				this.$store.getters.getLockState === lockGameStages.LIFE_STAGE_SUMMARY
			) {
				this.lockGameStage = lockGameStages.LIFE_STAGE_SUMMARY;
				passcodeToCheck = this.profileData.passcodes
					.afterLifeStageSummaryPasscode;
			} else if (
				this.profileData.cmsLifeStage.displayOrder === lifeStageOrders.TEENAGER
			) {
				this.lockGameStage = lifeStageOrders.TEENAGER;
				passcodeToCheck = this.profileData.passcodes.afterLifeScenarioPasscode;
			} else if (
				this.profileData.cmsLifeStage.displayOrder ===
					lifeStageOrders.YOUNG_ADULT ||
				lifeStageOrders.WORKING_ADULT ||
				lifeStageOrders.ADULT_RETIREMENT ||
				lifeStageOrders.ADULT_RETIREMENTR
			) {
				this.lockGameStage = lifeStageOrders.YOUNG_ADULT;

				passcodeToCheck = this.profileData.passcodes.afterLifeScenarioPasscode;
			}
			if (this.userPasscode !== passcodeToCheck) {
				this.passcodeValidationErrors.push(this.$t('incorrectPasscode'));
				return;
			}
			this.isNextButtonDisabled = true;

			await ProfileService.updatePasscodeValidation(
				this.userData.studentId,
				this.lockGameStage
			);
			this.$store.dispatch('getProfileData').then(() => {
				this.isNextButtonDisabled = false;
			});
			this.$store.dispatch('showLifeStageSummary');
			this.$store.dispatch('showLifeStageIntro');
			this.$store.dispatch('showModalConfirmBudgetVisible');
			this.$store.dispatch('showModalAfterLifeStageIntro');
			this.$store.dispatch('showModalCalculateNMI');
			this.$emit('onSuccess', this.lockGameStage);
		},
		cancel() {
			this.$emit('cancel');
		},
		getLockState() {}
	}
};
</script>

<style lang="scss" scoped>
.passcode {
	::v-deep label,
	::v-deep.error-msg {
		text-align: left;
	}

	min-height: 160px;
	padding-top: 32px;

	@media (min-width: $breakpoint-min) and (max-width: $breakpoint-mid) {
		padding-top: 16px;
	}
}
.info-modal {
	z-index: 99999;
}
</style>
